import { Box, Button, Dialog, DialogProps } from "@mui/material";
import React, { useCallback, useState } from "react";
// import SavingLoader from "../SavingLoader/SavingLoader";
// import Image from "next/image";
// import styles from "@/styles/pages/home.module.scss";
import styles from "../../../styles/pages/home.module.scss";
import CloseIcon from "@mui/icons-material/Close";
// import assest from "@/json/assest";
import assest from "../../../json/assest";
import SavingLoader from "../SavingLoader/SavingLoader";
import { useMutation, useQueryClient } from "react-query";
import axiosInstance from "../../../api/axiosInstance";

const dialogContainer = {
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",
  },
};

// export type InvitationModalProps = DialogProps;
export default function InvitationModal(props) {
  const { onClose, invitationData, refetch, ...rest } = props;
  const queryClient = useQueryClient();
  const [cancel, setCancel] = useState(false);
  const [openSavingLoader, setOpenSavingLoader] = useState(false);
  const [processComplete, setProcessComplete] = useState(false);
  const [successText, setSuccessText] = useState("");
  console.warn("invitationData", invitationData);
  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
      setTimeout(() => {
        setCancel(false);
      }, 500);
    },
    [onClose]
  );

  /*   const handleOpenSavingLoader = useCallback(
    (text) => (e) => {
      handleClose(e);
      setOpenSavingLoader(true);
      setProcessComplete(false);
      setSuccessText(text);
      setTimeout(() => {
        setProcessComplete(true);
      }, 500);
    },
    [handleClose]
  ); */

  const handleOpenSavingLoader = (text) => {
    setOpenSavingLoader(true);
    setProcessComplete(false);
    setSuccessText(text);
    setTimeout(() => {
      setProcessComplete(true);
    }, 800);
  };

  const handleCloseSavingLoader = useCallback(() => {
    setOpenSavingLoader(false);
    setTimeout(() => {
      setSuccessText("");
    }, 500);
  }, []);
  const formatDate = (inputDateStr) => {
    const inputDate = new Date(inputDateStr);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return inputDate.toLocaleDateString(undefined, options);
  };

  const handleSend = async () => {
    const data = {
      id: invitationData?.id,
    };
    await axiosInstance
      .post("admin/resent-invite", data)
      .then((res) => {
        console.warn("res", res);
        if (res?.status === 200) {
          handleClose();
          refetch();
          // queryClient.invalidateQueries(["PendingInvitationsList"]);
          handleOpenSavingLoader("Invite Successfully Resent");
        }
      })
      .catch((err) => {
        if (err?.data?.message) {
          toastError(err?.data?.message);
        }
      });
  };

  const handleDelete = async () => {
    try {
      const response = await axiosInstance.delete(
        `admin/user/${invitationData?.id}/delete`
      );
      if (response.status === 200) {
        handleClose();
        refetch();
        handleOpenSavingLoader("Invite Successfully Canceled");
      }
    } catch (error) {
      // Handle error, e.g., display an error message
      console.error("Error deleting user:", error);
    }
  };

  return (
    <>
      <Dialog
        {...rest}
        onClose={handleClose}
        sx={dialogContainer}
        className={
          cancel
            ? `${styles.invitationCancelModal} ${styles.invitationCancelModal_new} invitationModalCancel`
            : `${styles.invitationModalInr} invitationModal`
        }
      >
        <Box className={`${styles.closs_btn} ${styles.clossingSvn_btn}`}>
          <Button autoFocus onClick={handleClose} className="crossModal">
            <CloseIcon />
          </Button>
        </Box>
        {!cancel && (
          <Box
            className={`${styles.card_modal_cont} ${styles.card_modal_contrbtns}`}
          >
            <p>
              Your Invitation to{" "}
              <b>{`${invitationData?.name} ${invitationData?.last_name}`}</b>{" "}
              for <b>{invitationData?.role?.display_name}</b> access sent on{" "}
              <b>{formatDate(invitationData?.created_at)}</b> is still pending.
            </p>
            <Box className={styles.btnbar}>
              <Box className={`${styles.btnbar1} ${styles.btnbarcancels}`}>
                <button
                  className={styles.cancle_btn}
                  onClick={() => setCancel(true)}
                >
                  Cancel Invitation
                </button>
                <button
                  className={`${styles.cancle_btn} cancle_btn`}
                  onClick={handleSend}
                  // onClick={handleOpenSavingLoader("Invite Successfully Resent")}
                >
                  Send again
                </button>
              </Box>
              <Box className={`${styles.btnbar1} ${styles.btnbrClosehn}`}>
                <button className={styles.close_btn} onClick={handleClose}>
                  Close
                </button>
              </Box>
            </Box>
          </Box>
        )}
        {cancel && (
          <Box
            className={`${styles.card_modal_cont1} ${styles.card_modal_cont1Icons} ${styles.card_cancelinvt_modal}`}
          >
            <img
              className={styles.modl_iconimgs}
              src={assest.modalicon}
              width={6}
              height={31}
              alt=""
            />
            <p className={styles.modal_cont}>
              Are you sure you want to cancel this invite?
            </p>
            <Box className={styles.btnbar}>
              <Box className={styles.btnbar1}>
                <button className={styles.close_btn} onClick={handleDelete}>
                  Yes
                </button>
              </Box>
              <Box className={styles.btnbar1}>
                <button className={styles.cancle_btn} onClick={handleClose}>
                  No
                </button>
              </Box>
            </Box>
          </Box>
        )}
      </Dialog>
      <SavingLoader
        open={openSavingLoader}
        onClose={handleCloseSavingLoader}
        successText={successText}
        processSuccess={processComplete}
      />
    </>
  );
}
